import React from "react";
import styled from "styled-components";
import { FaDonate } from "react-icons/fa";

const SupportContainer = styled.div`
  min-height: 50rem;
  width: 80%;
  background: #f7f7f7;
  margin: auto;
  box-shadow: 0px 1px 6px #00000024;
  margin-top: 7rem;
  border-radius: 1rem;
  overflow: hidden;
  @media (max-width: 768px) {
    width: 95% !important;
  }
`;
const Heading = styled.h2`
  font-size: 1.3rem;
  color: #393939;
  line-height: 2rem;
  font-family: Poppins;
  text-align: center;
  @media (max-width: 768px) {
    span {
      font-size: 1.1rem;
      word-break: break-all;
    }
  }
`;

const Support = () => {
  const address = "hx38c5fea8a8321e17a8ee7c6b5835a4731b1134cf";

  return (
    <SupportContainer>
      <Heading>
        <FaDonate
          style={{
            marginTop: "1.8rem",
            color: "#f39c12",
            // color: "white",
            fontSize: "10rem",
          }}
        />
        <br />
        <br />
        Created By :{" "}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://twitter.com/akhilchief"
        >
          Hecker
        </a>
        <p style={{ color: "#3772ff" }}>
          Contact me on twitter to add your collection
        </p>
        <br />
        <span>
          {" "}
          <br />
          More interesting features are coming soon. <br />
          Keep supporting my work buying me cup of coffee. ($ICX, $GBET, $BALN,
          NFTs or any ICON network Assets):
        </span>
        <br />
        <br />
        <span
          style={{
            marginTop: "1rem",
            paddingTop: "1rem",
          }}
        >
          Wallet Address(Click To Copy) : <br />
          <span
            onClick={() => {
              navigator.clipboard.writeText(address);
              alert("Address Copied Success");
            }}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "#000",
            }}
          >
            hx38c5fea8a8321e17a8ee7c6b5835a4731b1134cf
          </span>
        </span>
      </Heading>
    </SupportContainer>
  );
};
export default Support;
